import { asyncHandler } from './async-handler';
import { RequestInfo } from '../../interfaces/RequestInfo';
import { PRE_USER_INVITATION_API } from '../constants/central-api';
import { submitLogToBugsnag } from './log';
import store from '../../store/store';
import { clearPreUserInvitation } from '../../store/reducers/userSlice';

export async function requestPreUserInvitation(
  invitationId: string
): Promise<any | false> {
  try {
    store.dispatch(clearPreUserInvitation());

    const requestInfo: RequestInfo = {
      url: PRE_USER_INVITATION_API(invitationId),
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/x-www-form-urlencoded',
      },
    };

    const actionType = 'PRE_USER_INVITATION_VERIFICATION';
    const customMsg = 'Pre-user invitation verification successful';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response = res.data;

    if (
      res.actionType === actionType &&
      response?.success &&
      response?.data?.user_data
    ) {
      return response;
    } else {
      return false;
    }
  } catch (exception) {
    console.log('Error during pre-user invitation request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
